import React, { useCallback } from 'react';
import { pick } from 'ramda';

import window from 'window';

import {
  mergeApplication,
  selectCreditApplication,
} from 'state/creditApplication';

import FmcForm from 'components/FmcForm';
import { RouteComponentProps } from 'react-router-dom';
import UnifiedFullApplication from './UnifiedFullApplication';
// import MultiStepApplication from './MultiStepApplication';

import { useDispatch, useSelector } from 'react-redux';
import useNavigationHelpers from 'hooks/useNavigationHelpers';

import useWorkflow, { Step } from 'hooks/useWorkflow';

import useSchema, { FormValues } from './useSchema';
import useLocateAndAttribute from 'hooks/useLocateAndAttribute';
import useGeolocation from 'hooks/useGeolocation';

type PropTypes = RouteComponentProps;

const fields = [
  'firstName',
  'lastName',
  'address1',
  'address2',
  'city',
  'state',
  'zip',
  'emailAddress',
  'dateOfBirth',
  'alternativePhone',
  'ssn',
  'mobilePhone',
  'studentApplication',
];

const UnifiedPrequalOfferPushApplication: React.FC<PropTypes> = () => {
  const application = useSelector(selectCreditApplication);
  const dispatch = useDispatch();
  const [shouldGeolocate] = useGeolocation();
  const { push } = useNavigationHelpers();
  const { pathAfter } = useWorkflow();
  const schema = useSchema();

  const locateAndAttribute = useLocateAndAttribute();

  const onSubmit = useCallback(
    async (values: FormValues) => {
      const castValues = schema.cast(values);
      dispatch(mergeApplication(castValues));
      // In Samsung Internet, the location prompt is not blocking.
      // When a user is focused on the last element of the form, they may press
      // on submit button on the virtual keyboard. This doesn't blur the input,
      // and the keyboard remains open and cover up the location prompt.
      if (window.document && 'activeElement' in window.document) {
        (window.document.activeElement as HTMLElement).blur();
      }

      await locateAndAttribute(castValues);

      push(pathAfter(Step.UNIFIED_PREQUAL_OFFER_PUSH_APPLICATION));
    },
    [schema, dispatch, locateAndAttribute, push, pathAfter],
  );

  const initialValues: FormValues = pick(fields, application);

  return (
    <FmcForm
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {formikProps => {
        return (
          <UnifiedFullApplication
            {...formikProps}
            shouldGeolocate={shouldGeolocate}
          />
        );
      }}
    </FmcForm>
  );
};

export default UnifiedPrequalOfferPushApplication;
